import styled from 'styled-components';

export const HorizontalDivider = styled.div`
  height: 1px;
  background-color: ${props => props.color || props.theme.palette.grayScale[20]}
  margin-top: ${props => props.margin || '16px'}
  margin-bottom: ${props => props.margin || '16px'}
`;
